import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  LinearProgress,
  AppBar,
  Toolbar,
  Card,
  CardContent,
} from '@mui/material';
import { styled } from '@mui/system';
import SitemarkIcon from '../../components/common/SitemarkIcon';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Header = styled(AppBar)({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
  padding: '12px 40px',
});

const Step2WhatsApp = ({ form, setForm, onBack, onNext }) => {
  const [whatsappNumber, setWhatsappNumber] = useState(form.whatsapp?.number || '');
  const [errors, setErrors] = useState({});

  const clearError = (field) => {
    setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const handleNext = () => {
    const newErrors = {};

    if (!whatsappNumber.trim()) {
      newErrors.whatsappNumber = 'Este campo es obligatorio';
    } else if (!/^\+?[1-9]\d{1,14}$/.test(whatsappNumber.replace(/\s|-/g, ''))) {
      newErrors.whatsappNumber = 'Formato de número inválido. Use formato internacional (ej: +1234567890)';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setForm({
        ...form,
        whatsapp: {
          number: whatsappNumber.trim(),
        },
      });
      onNext();
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #4a9b94 0%, #3a7a73 100%)',
        fontFamily: 'Inter, Noto Sans, sans-serif',
      }}
    >
      <Header position="static">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box display="flex" alignItems="center" gap={2}>
            <SitemarkIcon />
            <Typography variant="h6" sx={{ fontWeight: 600, color: 'white' }}>
              Bankivo Assist
            </Typography>
          </Box>
        </Toolbar>
      </Header>

      <Container maxWidth="md" sx={{ py: 5 }}>
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'white', mb: 1 }}>
            Configuración de WhatsApp
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
            Paso 2: Configura tu número de WhatsApp Business
          </Typography>
        </Box>

        <Card sx={{ borderRadius: 2, boxShadow: 4 }}>
          <CardContent sx={{ p: 4 }}>
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'center' }}>
              <Box
                sx={{
                  p: 2,
                  borderRadius: 2,
                  backgroundColor: 'success.light',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <WhatsAppIcon sx={{ fontSize: 40, color: 'success.main' }} />
              </Box>
            </Box>

            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
                Número de WhatsApp Business *
              </Typography>
              <TextField
                placeholder="+1234567890"
                fullWidth
                value={whatsappNumber}
                onChange={(e) => {
                  setWhatsappNumber(e.target.value);
                  clearError('whatsappNumber');
                }}
                error={!!errors.whatsappNumber}
                helperText={errors.whatsappNumber || 'Ingresa el número en formato internacional (ej: +1234567890)'}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1,
                    backgroundColor: '#F8F9FA',
                  },
                }}
              />
            </Box>

            <Box sx={{ mt: 3, p: 2, backgroundColor: 'info.light', borderRadius: 1 }}>
              <Typography variant="body2" color="info.dark">
                <strong>Nota:</strong> Este número debe estar registrado en WhatsApp Business API. 
                Asegúrate de tener acceso a este número para recibir mensajes de verificación.
              </Typography>
            </Box>
          </CardContent>
        </Card>

        <Box mt={4}>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', mb: 1 }}>
            Paso 2 de 3
          </Typography>
          <LinearProgress
            variant="determinate"
            value={66}
            sx={{
              bgcolor: 'rgba(255, 255, 255, 0.3)',
              height: 8,
              borderRadius: 1,
              '& .MuiLinearProgress-bar': {
                bgcolor: 'white',
              },
            }}
          />
        </Box>

        <Box display="flex" justifyContent="space-between" mt={4}>
          <Button
            variant="outlined"
            onClick={onBack}
            sx={{
              fontWeight: 600,
              borderRadius: 1,
              px: 4,
              py: 1.5,
              textTransform: 'none',
              borderColor: 'white',
              color: 'white',
              '&:hover': {
                borderColor: 'rgba(255, 255, 255, 0.8)',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            Anterior
          </Button>
          <Button
            variant="contained"
            onClick={handleNext}
            sx={{
              fontWeight: 600,
              borderRadius: 1,
              px: 4,
              py: 1.5,
              textTransform: 'none',
              backgroundColor: 'white',
              color: '#18586b',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
              },
            }}
          >
            Continuar
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Step2WhatsApp;

